var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('import-match',{ref:"match",attrs:{"import-type":"campaign","page-subtitle":_vm.selectedCampaign.name,"path-prefix":"campaigns"},on:{"cancel":_vm.onCancel,"not-found":_vm.onNotFound,"preview":_vm.onPreview}})}
var staticRenderFns = []

export { render, staticRenderFns }